import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Sidebar } from '../components/Sidebar';
import { Dashboard } from '../components/Dashboard';
import { ProductionView } from '../components/ProductionView';
import { Settings } from '../components/Settings';
import { TimerProvider } from '../context/TimerContext';
export function ProductionModule() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return <TimerProvider data-id="element-1296">
      <div className="flex w-full min-h-screen bg-gray-100" data-id="element-1297">
        <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} data-id="element-1298" />
        <main className={`flex-1 p-4 overflow-auto transition-all duration-300
            ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-16'}`} data-id="element-1299">
          <Routes data-id="element-1300">
            <Route path="/" element={<Dashboard data-id="element-1302" />} data-id="element-1301" />
            <Route path="/view" element={<ProductionView data-id="element-1304" />} data-id="element-1303" />
            <Route path="/settings" element={<Settings data-id="element-1306" />} data-id="element-1305" />
          </Routes>
        </main>
      </div>
    </TimerProvider>;
}